import { isEmbeddedMobile } from "./chief-bridge";

export enum StorageKeys {
  isDarkMode = "isDarkMode",
  device = "device",
  language = "language",
  buildNumber = "buildNumber",
  quoteColor = "quoteColor", // 行情涨跌配色：RUGD=红涨绿跌，RDGU=红跌绿涨
  // after login
  privilege = "privilege",
  apiKey = "apiKey",
  accessToken = "accessToken",
  clientCode = "clientCode",
  channel = "channel",
  headerMargin = "headerMargin", // 必须是大于等于0的数字，单位px，否则无效
  footerMargin = "footerMargin", // 必须是大于等于0的数字，单位px，否则无效
  iosVersion = "iosVersion",
  aosVersion = "aosVersion",
  pcVersion = "pcVersion", // 桌面端（Mac/Windows）版本号，键名待与桌面端确认
}
export enum LangEnums {
  enUS = "1",
  zhHK = "2",
  zhCN = "3",
  koKR = "4",
}

export function langEnumToLangHeader(params: LangEnums) {
  switch (params) {
    case LangEnums.enUS:
      return "en_US";
    case LangEnums.zhHK:
      return "zh_HK";
    case LangEnums.zhCN:
      return "zh_CN";
    case LangEnums.koKR:
      return "ko_KR";
    default:
      return "zh_HK";
  }
}

export type StorageModel = Partial<{
  [StorageKeys.isDarkMode]: "Y" | "N";
  [StorageKeys.device]: string;
  [StorageKeys.language]: LangEnums;
  [StorageKeys.buildNumber]: string;
  [StorageKeys.quoteColor]: string;
  [StorageKeys.privilege]: "Y" | "N";
  [StorageKeys.apiKey]: string;
  [StorageKeys.accessToken]: string;
  [StorageKeys.clientCode]: string;
  [StorageKeys.channel]: string;
  [StorageKeys.headerMargin]: string;
  [StorageKeys.footerMargin]: string;
  [StorageKeys.iosVersion]: string;
  [StorageKeys.aosVersion]: string;
  [StorageKeys.pcVersion]: string;
}>;

export const storageModel: StorageModel = {};
for (const key in StorageKeys) {
  const storageKey = StorageKeys[key as keyof typeof StorageKeys];
  const value = localStorage.getItem(storageKey);
  if (value) {
    storageModel[storageKey] = value as unknown as any;
  }
}

export function reloadStorageModel(delay: number = 0): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      for (const key in StorageKeys) {
        const storageKey = StorageKeys[key as keyof typeof StorageKeys];
        const value = localStorage.getItem(storageKey);
        if (value) {
          storageModel[storageKey] = value as unknown as any;
        }
      }
      resolve();
    }, delay);
  });
}
// console.log("storageModel", storageModel);
